import React from "react";

type BtnProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    tone?: "primary" | "quiet" | "danger";
    /** `lg` is the 44px touch-target size for phone surfaces; `md` suits the desktop console. */
    size?: "md" | "lg";
};

/**
 * The design's two button weights: a filled accent call-to-action, and the quiet outlined chip
 * used for filters and secondary actions.
 */
export const Btn: React.FC<BtnProps> = ({ tone = "primary", size = "md", className = "", children, ...rest }) => {
    const toneCls = {
        primary: "bg-[var(--accent)] text-[var(--accent-in)] border border-[var(--accent)] hover:brightness-110",
        quiet: "bg-[var(--surface)] text-[var(--muted)] border border-[var(--line-2)] hover:text-[var(--text)]",
        danger: "bg-[color-mix(in_srgb,var(--crit)_calc(var(--tint)*100%),transparent)] text-[var(--crit)] border border-[color-mix(in_srgb,var(--crit)_45%,transparent)]",
    }[tone];
    const sizeCls = size === "lg" ? "min-h-11 px-5 text-[14.5px]" : "min-h-9 px-4 text-[13.5px]";
    return (
        <button
            type="button"
            className={`inline-flex items-center justify-center gap-2 rounded-[11px] font-semibold disabled:opacity-45 ${toneCls} ${sizeCls} ${className}`}
            {...rest}
        >
            {children}
        </button>
    );
};
